<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/yr/pbanner.png" alt="">
            <p id="topt"></p>
        </div>
        <div class="main">
            <div class="mainCon">
                <div class="nav">
                    <span @click="goto(0)">{{$t('proInfo2').text1}} /</span>
                    <span @click="goto(1)">{{$t('proInfo2').text2}}</span>
                </div>
               <div class="allItems">
                   <div class="item" v-for="(item,index) in list" :key="index" @click="gotoPro(item.ID,item.CALLED,item.ISNEED)">
                          <div class="i1">
                              <img :src="`http://www.yourlonglighting.com/upload/${item.FILE}`" alt="">
                          </div>

<!--                       <div class="i2">-->
<!--                           <p class="name">{{item.CALLED}}</p>-->
<!--                           <div class="content">-->
<!--                          {{item.TEXT1}}-->
<!--                           </div>-->
<!--                           <p class="show">Show-->
<!--                               <span> <i class="iconfont icon-xiangyou"></i></span>-->
<!--                           </p>-->
<!--                       </div>-->

                   </div>
               </div>
<!--                <div class="proList">-->
<!--                    <p class="title">{{text}}</p>-->
<!--                                    <div class="oneItem" v-for="(item,index) in proList" :key="index">-->
<!--                                            <router-link :to="{path: 'proInfo',query:{id:item.ID}}" target="_blank">-->
<!--                                                <img :src="`http://www.yourlonglighting.com/upload/${item.SMALLPIC}`" alt="">-->
<!--                                            <p class="t1">{{item.PRONAME}}</p>-->
<!--                                            <div class="last">-->
<!--                                                <p>{{item.TITLE2}}</p>-->
<!--                                                <i class="iconfont icon-youjiantou"></i>-->
<!--                                            </div>-->
<!--                                            </router-link>-->
<!--                                        </div>-->

<!--                                        <div style="width:100%;text-align: center;margin-top: 40px" @click="showMore">-->
<!--                                            <ban-Component :text="$t('btn')" ></ban-Component>-->
<!--                                        </div>-->
<!--                </div>-->
            </div>
        </div>
        <el-dialog title="User Info" :visible.sync="dialogFormVisible" id="dialog" :style="dStyle">
            <el-form :mode="form">
                <el-form-item label="PassWord">
                    <el-input v-model="form.password" type="password" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="confirm">Confirm</el-button>
            </div>
        </el-dialog>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import banComponent from '../components/btn'
    import {getProductstypeUrl2,getProductsUrl} from '../util/lang'
    import Scrollbar from 'smooth-scrollbar'
    import '../common/jquery-1.11.3.min'
    export default {
        name: "pro",
        data(){
            return{
                dStyle:{},
                text:'Products',
                id:'',
                text2:'',
                page:'',
                totalPage:'',
                num:'',
                list:[],
                proList:[],
                scrollbar:'',
                top:'',
                dialogFormVisible:false,
                form:{
                    password:''
                },
            }
        },
        components:{footComponent,banComponent},
        watch:{
            '$route': 'go',
        },
        mounted(){
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            scrollbar.scrollTo(0,0)
            this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
            this.scrollbar.addListener((status) => {
                this.dStyle={marginTop:status.offset.y+'px'}
                $(".main div").each(function() {
                    var _this = $(this);
                    if ($(window).scrollTop() >= $(this).offset().top - $(window).height() + 20)
                    {
                        _this.addClass('show');
                    }else{
                        _this.removeClass('show');
                    }
                });
                window.pageYOffset=this.scrollbar.scrollTop
            });
            if(this.$i18n.locale==='en'){
                this.getPro('72')
            }else{
                this.getPro('84')
            }
            setTimeout(()=>{
                Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#topt"),{
                    offsetTop: 80,
                })
            },1100)
            // if(this.$route.query.index!==undefined){
            //     this.showRight2(this.$route.query.index,this.$route.query.id,this.$route.query.text)
            // }else if(this.$route.query.id!==undefined){
            //     this.text=this.$route.query.text
            //     this.num=parseInt(this.$route.query.num)
            //     this.getProducts(this.$route.query.id)
            // }
            // else{
            //     if(this.$i18n.locale==='en'){
            //         this.getProducts('72')
            //         this.text='Products'
            //     }else{
            //         this.text='所有产品'
            //         this.getProducts('60')
            //     }
            // }
        },
        methods:{
            confirm(){
                if(this.form.password!=='66668888'){
                    this.$notify({
                        title: 'Sorry',
                        message: 'Please enter the complete information',
                        offset: 100
                    });
                }else {
                    this.form={
                        password:''
                    }
                    this.dialogFormVisible=false
                    this.$notify({
                        title: 'Correct',
                        message: 'Coming to the next page',
                        offset: 100
                    });
                    setTimeout(()=>{
                        this.$router.push({path:'/proList',query:{id:this.id,text:this.text}})
                        this.$router.go(0)
                    },100)
                }
            },
            gotoPro(id,t,isneed){
                if(isneed==='1')
                {
                    this.id=id
                    this.text2=t
                    this.top=this.scrollbar.scrollTop
                    this.form={
                        password:''
                    }
                    this.dialogFormVisible=true
                }else{
                    this.$router.push({path:'/proList',query:{id:id,text:t}})
                }
            },
            goto(n){
                if(n===0){
                    this.$router.push({path:'/'})
                }else{
                    this.$router.push({path:'/pro'})
                }
            },
            showMore(){
                if(this.page<=this.totalPage){
                    const url = `${getProductsUrl(this.$i18n.locale,this.id,9,this.page++)}`
                    this.$axios.get(url).then(res => {
                        this.proList=this.proList.concat(res.data.proarr)
                    })
                }else{
                    this.$notify({
                        title: 'Prompt',
                        message: 'Already loaded',
                        offset: 100
                    });
                }
            },
            showRight(n,id){
                this.num=n
                this.id=id
                this.page=2
                this.text=this.list[n].CALLED
                this.$router.push({
                    name: 'Pro',
                    query: {id: id,text:this.text,num:n}       //   params: {toseId: toseId}
                })
                const url = `${getProductsUrl(this.$i18n.locale,id,9,1)}`
                this.$axios.get(url).then(res => {
                    this.proList=res.data.proarr
                    this.totalPage=res.data.pagershow.totalPagers
                })
            },
            showRight2(n,id,t){
                this.num=n
                this.id=id
                this.page=2
                this.text=t
                const url = `${getProductsUrl(this.$i18n.locale,id,9,1)}`
                this.$axios.get(url).then(res => {
                    this.proList=res.data.proarr
                    this.totalPage=res.data.pagershow.totalPagers
                })
            },
            getProducts(id){
                this.id=id
                this.page=2
                const url = `${getProductsUrl(this.$i18n.locale,id,9,1)}`
                this.$axios.get(url).then(res => {
                    this.proList=res.data.proarr
                   this.totalPage=res.data.pagershow.totalPagers
                })
            },
            getPro(id){
                this.$nextTick(()=>{
                    const url = `${getProductstypeUrl2(this.$i18n.locale,id)}`
                    this.$axios.get(url).then(res => {
                        this.list=res.data
                        console.log(this.list)
                    })
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    background-color: #F4F4F4;
    animation: down 2s linear;
    @keyframes down {
        from{
            transform: translateX(-30px);
        }
        to{
            transform: translateX(0);
        }
    }
    .banner{
    width:100%;
        position: relative;
        overflow: hidden;
        p{
            position: absolute;
            width:100%;
            left:0;
            top:50%;
            height:60px;
        }
    img{
        width:100%;
        object-fit: cover;
        display: block;
        animation: big 1s linear forwards;
    }
        @keyframes big {
            from{
                transform: scale(1.1);
            }
            to{
                transform: scale(1);
            }
        }
}
    .main{
        width:100%;
        .mainCon{
            width:1280px;
            margin: 60px auto;
           padding-bottom: 40px;
            .nav{
                width:100%;
                margin: 30px 0;
                padding-top: 40px;
                span{
                    text-transform: uppercase;
                    padding-right: 5px;
                    cursor: pointer;
                    font-family: Calibri;
                }
                span:last-child{
                    color:#F4A000;
                }
            }
          .allItems{
              width:100%;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: space-between;
              .item{
                  margin-top: 130px;
                  cursor: pointer;
                  width:auto;
                  height:auto;
                  position: relative;
                  .i1{
                      overflow: hidden;
                      img{
                          display: block;
                          transition: all 600ms;
                      }
                  }
                  .i2{
                      position: absolute;
                      right: 0;
                      bottom: -10%;
                      padding: 15px 20px;
                      background-color: #fff;
                      width: 60%;
                      transition: all 600ms;
                      .name{
                          font-size: 30px;
                          transition: all 1s;
                      }
                      .name::after{
                          content: '';
                          display: block;
                          width: 54px;
                          height: 3px;
                          background-color: #ff9933;
                          margin-top: 10px;
                      }
                      .content{
                          color: #666;
                          font-size: 14px;
                          padding-bottom: 10px;
                          line-height: 25px;
                      }
                      .show{
                          transition: all 1s;
                         span{
                             margin-left: 20px;
                             i{
                                 color:#F4A000;
                                     vertical-align: middle;
                             }
                          }
                         i::before{
                             font-size: 20px;
                         }
                      }
                  }
              }
              .item:nth-child(even){
                  margin-top: 250px;
                  .i2{
                      bottom:-25%;
                  }
              }
              .item:hover{
                      img{
                          transform: scale(1.05);
                      }
                  .i2{
                      opacity: .95;
                      .name{
                          color:#F4A000;
                      }
                      .show{
                          transform: translateX(10px);
                      }
                  }
              }
          }
        }
        div{
            opacity: 0;
            transform: translateY(20px);
            transition: all 1s;
        }
        .show{
            opacity: 1;
            transform: translateY(0);
        }
    }
    @media screen and (max-width:450px){
        .banner{
            img{
                height:300px;
            }
        }
        .main{
            width:95%;
            margin-left: 2.5%;
          .mainCon{
              width:100%;
              flex-direction: column;
              .allItems{
                  flex-direction: column;
                  .item{
                      width:100%;
                      margin-left: 0;
                      margin-top: 40px !important;
                      .i1{
                          img{
                              width:100%;
                              object-fit: cover;
                          }
                      }
                      .i2{
                          width:80%;
                      }
                  }
              }
              /*.list{*/
              /*    flex-wrap: wrap;*/
              /*    span{*/
              /*        width:45%;*/
              /*        padding: 10px 0;*/
              /*        text-align: center;*/
              /*        font-size: 18px;*/
              /*        margin-top: 10px;*/
              /*    }*/
              /*}*/
              /*.proList{*/
              /*    .title{*/
              /*        font-size: 25px;*/
              /*    }*/
              /*    .oneItem{*/
              /*        width:100%;*/
              /*        margin-left: 0;*/
              /*    }*/
              /*}*/
          }
        }
    }
}
</style>
